// Module
var code = `<section class="page-body default-content">

  <h2>Forms</h2>
  <p>
    Forms are essential for capturing user input. The SpyneJS design system
    provides consistent, theme-aware styles for all form controls including
    text inputs, textareas, selects, checkboxes, and radios.
    Form components are designed to be accessible, responsive, and easily
    composable within your application.
  </p>

  <!-- Philosophy -->
  <h3>Design Philosophy</h3>
  <ul>
    <li>All controls inherit from the design system’s typography and spacing scale.</li>
    <li>Focus states are clearly visible and accessible by default.</li>
    <li>Disabled and error states are consistently styled across all controls.</li>
    <li>Form elements align with <code>--spacing</code>, <code>--font-size</code>, and <code>--brand</code> tokens.</li>
  </ul>

  <!-- States -->
  <h3>States</h3>
  <p>
    Each form control supports multiple states:
  </p>
  <ul>
    <li><strong>Default</strong> – neutral input style.</li>
    <li><strong>Focus</strong> – uses a visible focus ring and border highlight.</li>
    <li><strong>Disabled</strong> – muted background and text, with no interactions.</li>
    <li><strong>Error / Validation</strong> – custom states can be applied using semantic colors (danger, warning, success).</li>
  </ul>

  <!-- Components -->
  <h3>Form Components</h3>
  <p>
    Explore each form element type in detail:
  </p>
  <ul>
    <li>
      <a class="route-link" data-channel="ROUTE"
         data-page-id="elements" data-topic-id="forms" data-event-prevent-default="true"  data-option-id="input"
         href="/elements/forms/input">Inputs</a> – single-line text fields.
    </li>
    <li>
      <a class="route-link" data-channel="ROUTE"
         data-page-id="elements" data-topic-id="forms" data-event-prevent-default="true"  data-option-id="textarea"
         href="/elements/forms/textarea">Textareas</a> – multi-line text fields.
    </li>
    <li>
      <a class="route-link" data-channel="ROUTE"
         data-page-id="elements" data-topic-id="forms" data-event-prevent-default="true"  data-option-id="select"
         href="/elements/forms/select">Selects</a> – dropdown menus.
    </li>
    <li>
      <a class="route-link" data-channel="ROUTE"
         data-page-id="elements" data-topic-id="forms" data-event-prevent-default="true"  data-option-id="checkbox"
         href="/elements/forms/checkbox">Checkboxes</a> – binary options with multiple selection.
    </li>
    <li>
      <a class="route-link" data-channel="ROUTE"
         data-page-id="elements" data-topic-id="forms" data-event-prevent-default="true"  data-option-id="radio"
         href="/elements/forms/radio">Radio Buttons</a> – single selection among multiple options.
    </li>
  </ul>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always pair form controls with accessible <code>&lt;label&gt;</code> elements.</li>
    <li>Use semantic HTML input types (<code>email</code>, <code>password</code>, <code>number</code>) for built-in validation and keyboard support.</li>
    <li>Ensure focus rings are visible and maintain a 3:1 contrast ratio against backgrounds.</li>
    <li>Provide descriptive error messages and use ARIA attributes where needed for screen reader support.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;